// extracted by mini-css-extract-plugin
export var closeButton = "_12-5";
export var container = "_12-0";
export var contentContainer = "_12-1";
export var desktop = "_12-2";
export var fullModalImage = "_12-6";
export var mobile = "_12-3";
export var withImage = "_12-4";